<template>
    <div class="e-card e-rounding shadow-sm">
        <PremiumBanner/>
        <h1 class="h3">{{ $t('title.remoteOrderSettings') }}</h1>

        <Loader v-if="loading" />
        <p class="mb-1">{{$t('remoteOrder.info') }}</p>
        <p class="mb-3">{{ $t('remoteOrder.paymentGateway.buttonInfo') }}</p>

        <svg viewBox="0 0 620 125" fill="none" xmlns="http://www.w3.org/2000/svg" class="remote-order-illustration">
          <!-- Step 1: QR Code (card x=25, icon center=85) -->
          <rect x="25" y="8" width="120" height="88" rx="10" fill="#eef2fa"/>
          <rect x="62" y="22" width="46" height="46" rx="3" fill="none" stroke="#1e3d7a" stroke-width="2"/>
          <rect x="67" y="27" width="13" height="13" rx="1.5" fill="#1e3d7a"/>
          <rect x="70" y="30" width="7" height="7" rx="0.5" fill="#eef2fa"/>
          <rect x="72" y="32" width="3" height="3" fill="#1e3d7a"/>
          <rect x="88" y="27" width="13" height="13" rx="1.5" fill="#1e3d7a"/>
          <rect x="91" y="30" width="7" height="7" rx="0.5" fill="#eef2fa"/>
          <rect x="93" y="32" width="3" height="3" fill="#1e3d7a"/>
          <rect x="67" y="48" width="13" height="13" rx="1.5" fill="#1e3d7a"/>
          <rect x="70" y="51" width="7" height="7" rx="0.5" fill="#eef2fa"/>
          <rect x="72" y="53" width="3" height="3" fill="#1e3d7a"/>
          <rect x="88" y="48" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="94" y="48" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="100" y="48" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="88" y="54" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="100" y="54" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="94" y="60" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <rect x="100" y="60" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
          <text x="85" y="112" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" fill="#555">{{ $t('remoteOrder.illustration.step1') }}</text>

          <!-- Arrow 1 -->
          <line x1="147" y1="52" x2="171" y2="52" stroke="#3a6abf" stroke-width="2" stroke-linecap="round"/>
          <polyline points="165,46 173,52 165,58" stroke="#3a6abf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>

          <!-- Step 2: Phone (card x=175, icon center=235) -->
          <rect x="175" y="8" width="120" height="88" rx="10" fill="#eef2fa"/>
          <rect x="219" y="20" width="32" height="56" rx="5" fill="#1e3d7a"/>
          <rect x="222" y="25" width="26" height="40" rx="2" fill="#dde8f8"/>
          <rect x="226" y="30" width="10" height="2" rx="1" fill="#3a6abf"/>
          <rect x="238" y="30" width="7" height="2" rx="1" fill="#3a6abf" opacity="0.5"/>
          <rect x="226" y="35" width="18" height="1.5" rx="0.75" fill="#3a6abf" opacity="0.5"/>
          <rect x="226" y="39" width="14" height="1.5" rx="0.75" fill="#3a6abf" opacity="0.5"/>
          <rect x="226" y="43" width="16" height="1.5" rx="0.75" fill="#3a6abf" opacity="0.5"/>
          <rect x="226" y="49" width="18" height="9" rx="4" fill="#4caf50"/>
          <rect x="232" y="69" width="6" height="2" rx="1" fill="#3a6abf" opacity="0.4"/>
          <text x="235" y="112" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" fill="#555">{{ $t('remoteOrder.illustration.step2') }}</text>

          <!-- Arrow 2 -->
          <line x1="297" y1="52" x2="321" y2="52" stroke="#3a6abf" stroke-width="2" stroke-linecap="round"/>
          <polyline points="315,46 323,52 315,58" stroke="#3a6abf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>

          <!-- Step 3: POS (card x=325, icon center=385) -->
          <rect x="325" y="8" width="120" height="88" rx="10" fill="#eef2fa"/>
          <rect x="350" y="20" width="70" height="48" rx="4" fill="#1e3d7a"/>
          <rect x="354" y="24" width="62" height="38" rx="2" fill="#dde8f8"/>
          <rect x="358" y="29" width="28" height="2" rx="1" fill="#1e3d7a" opacity="0.4"/>
          <rect x="358" y="34" width="40" height="2" rx="1" fill="#1e3d7a" opacity="0.4"/>
          <rect x="358" y="39" width="22" height="2" rx="1" fill="#1e3d7a" opacity="0.4"/>
          <circle cx="400" cy="47" r="8" fill="#4caf50"/>
          <polyline points="395,47 399,51 405,43" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          <rect x="381" y="68" width="8" height="5" rx="1" fill="#1e3d7a"/>
          <rect x="373" y="72" width="24" height="3" rx="1.5" fill="#1e3d7a"/>
          <text x="385" y="112" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" fill="#555">{{ $t('remoteOrder.illustration.step3') }}</text>

          <!-- Arrow 3 -->
          <line x1="447" y1="52" x2="471" y2="52" stroke="#3a6abf" stroke-width="2" stroke-linecap="round"/>
          <polyline points="465,46 473,52 465,58" stroke="#3a6abf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>

          <!-- Step 4: Kitchen display (card x=475, icon center=535) -->
          <rect x="475" y="8" width="120" height="88" rx="10" fill="#eef2fa"/>
          <rect x="512" y="23" width="46" height="32" rx="3" fill="#1e3d7a"/>
          <rect x="515" y="26" width="40" height="26" rx="1.5" fill="#dde8f8"/>
          <rect x="517" y="28" width="16" height="21" rx="1.5" fill="white"/>
          <rect x="519" y="31" width="10" height="1.5" rx="0.5" fill="#3a6abf"/>
          <rect x="519" y="34" width="8" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
          <rect x="519" y="36" width="10" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
          <rect x="519" y="40" width="12" height="3" rx="1" fill="#4caf50"/>
          <rect x="535" y="28" width="16" height="21" rx="1.5" fill="white"/>
          <rect x="537" y="31" width="10" height="1.5" rx="0.5" fill="#3a6abf"/>
          <rect x="537" y="34" width="8" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
          <rect x="537" y="36" width="10" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
          <rect x="537" y="40" width="12" height="3" rx="1" fill="#ffc107"/>
          <rect x="531" y="55" width="8" height="6" rx="1" fill="#1e3d7a"/>
          <rect x="522" y="60" width="26" height="3" rx="1.5" fill="#1e3d7a"/>
          <text x="535" y="112" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" fill="#555">{{ $t('deviceMode.label.ordersDisplay') }}</text>
        </svg>

        <div v-if="!loading">
            <!-- Configuration Warnings -->
            <div v-if="(remoteOrderState === 'open' || remoteOrderState === 'scheduled') && (getSelectedCategoriesCount() === 0 || (paymentRequired && paymentProvider === 'noProvider'))" class="alert alert-warning mb-4">
              <div class="mb-2">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <strong>{{ $t('remoteOrder.wizard.incompleteConfiguration') }}</strong>
              </div>
              <ul class="mb-0 pl-3">
                <li v-if="getSelectedCategoriesCount() === 0">{{ $t('remoteOrder.wizard.warningNoCategories') }}</li>
                <li v-if="paymentRequired && paymentProvider === 'noProvider'">{{ $t('remoteOrder.wizard.warningNoPaymentGateway') }}</li>
              </ul>
            </div>

            <!-- Remote Order System State -->
            <div class="mb-4 p-3 border rounded">
              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <div class="mb-2 mb-md-0">
                  <strong>{{ $t('remoteOrder.systemTitle') }}</strong>
                  <div :class="{'text-success': remoteOrderState === 'open', 'text-danger': remoteOrderState === 'closed', 'small': remoteOrderState === 'scheduled'}">{{ getRemoteOrderStateText() }}</div>
                </div>
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-sm" :class="remoteOrderState === 'closed' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('closed')">
                        {{ $t('remoteOrder.state.closed') }}
                    </label>
                    <label class="btn btn-sm" :class="remoteOrderState === 'open' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('open')">
                        {{ $t('remoteOrder.state.open') }}
                    </label>
                    <label class="btn btn-sm" :class="remoteOrderState === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('scheduled')">
                        {{ $t('remoteOrder.state.scheduled') }}
                    </label>
                </div>
              </div>
              <div v-if="remoteOrderState === 'scheduled'" class="mt-3 d-flex justify-content-between align-items-center">
                <div v-if="weekOpenCloseSettings && weekOpenCloseSettings.actualTime">
                  {{ $t('remoteOrder.schedule.actualTime') }}: {{ hourMinuteToTimeString(weekOpenCloseSettings.actualTime) }} - <strong :class="weekOpenCloseSettings.openNow ? 'text-success' : 'text-danger'">{{ weekOpenCloseSettings.openNow ? $t('remoteOrder.schedule.openNow') : $t('remoteOrder.schedule.closedNow') }}</strong>
                  ({{ weekOpenCloseSettings.timeZone}})
                </div>
                <button class="btn btn-link btn-sm text-decoration-none p-0 ml-auto" @click="showScheduleDetails = !showScheduleDetails">
                  {{ showScheduleDetails ? $t('remoteOrder.schedule.hide') : $t('remoteOrder.schedule.show') }}
                  <i class="fas ml-1" :class="showScheduleDetails ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </div>

              <!-- Schedule Settings -->
              <div v-if="showScheduleDetails" class="mt-4 pt-3 border-top">
                <h5 class="mb-3">{{ $t('remoteOrder.schedule.title') }}</h5>
                <div v-for="(day, index) in weekSchedule" :key="index" class="row mb-3 align-items-center">
                    <div class="col-md-2">
                        <strong>{{ $t(day.nameKey) }}</strong>
                    </div>
                    <div class="col-md-4">
                        <div class="btn-group btn-group-toggle btn-group-sm w-100">
                            <label class="btn btn-sm" :class="day.state === 'closed' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'closed'">
                                {{ $t('remoteOrder.dayState.closed') }}
                            </label>
                            <label class="btn btn-sm" :class="day.state === 'open' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'open'">
                                {{ $t('remoteOrder.dayState.open') }}
                            </label>
                            <label class="btn btn-sm" :class="day.state === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'scheduled'">
                                {{ $t('remoteOrder.dayState.scheduled') }}
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{ $t('remoteOrder.schedule.timeFrom') }}</span>
                            </div>
                            <input type="time" class="form-control" v-model="day.from" :disabled="day.state !== 'scheduled'">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{ $t('remoteOrder.schedule.timeTo') }}</span>
                            </div>
                            <input type="time" class="form-control" v-model="day.to" :disabled="day.state !== 'scheduled'">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button class="btn btn-success" @click="saveWeekSchedule">
                        <i class="fas fa-save mr-2"></i>{{ $t('remoteOrder.schedule.save') }}
                    </button>
                </div>
              </div>
            </div>

            <!-- Main button - Wizard -->
            <div class="mb-4">
              <button @click="openWizard" class="btn btn-primary btn-lg btn-block">
                <i class="fas fa-magic mr-2"></i>
                {{ $t('remoteOrder.buttons.wizard') }}
              </button>
            </div>

            <!-- Three settings buttons -->
            <div class="row mb-4">
              <div class="col-12 col-md-4 mb-3 mb-md-0">
                <button @click="openModeSettingsModal" class="btn btn-outline-primary btn-block">
                  <i class="fas fa-cog mr-2"></i>
                  {{ $t('remoteOrder.buttons.modeSettings') }}
                </button>
              </div>
              <div class="col-12 col-md-4 mb-3 mb-md-0">
                <button @click="showCategorySettings = true" class="btn btn-outline-primary btn-block">
                  <i class="fas fa-list mr-2"></i>
                  {{ $t('remoteOrder.buttons.categorySettings') }}
                </button>
              </div>
              <div class="col-12 col-md-4">
                <button @click="openPaymentGatewayModal" class="btn btn-outline-primary btn-block">
                  <i class="fas fa-credit-card mr-2"></i>
                  {{ $t('remoteOrder.buttons.paymentGateway') }}
                </button>
              </div>
            </div>

            <!-- Download QR codes button -->
            <div>
              <button @click="openQRModal" class="btn btn-success btn-block">
                <i class="fas fa-qrcode mr-2"></i>
                {{ $t('remoteOrder.buttons.downloadQR') }}
              </button>
            </div>

        </div>

        <!-- Modal: Setup Wizard -->
        <div class="e-card-backdrop" v-if="showWizard">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-7 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.wizard.title') }} ({{ $t('remoteOrder.wizard.step') }} {{ wizardStep }}/6)</span>
                <i @click="closeWizard" class="fas fa-times e-modal-close-icon"></i>
              </div>
              <div v-if="wizardSettings" class="card-body py-5 px-4">

                <!-- Step 1: Business type -->
                <div v-if="wizardStep === 1">
                  <h5 class="mb-4">{{ $t('remoteOrder.wizard.step1.title') }}</h5>
                  <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step1.subtitle') }}</p>

                  <div class="mb-3">
                    <div
                      @click="wizardSettings.businessType = 'table'"
                      class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                      :class="{ 'wizard-choice-active': wizardSettings.businessType === 'table' }">
                      <div class="card-body py-4 px-4">
                        <div class="d-flex align-items-center">
                          <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                            <i class="fas fa-utensils"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h5 class="mb-1">{{ $t('remoteOrder.wizard.step1.table') }}</h5>
                            <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step1.tableDesc') }}</small>
                          </div>
                          <div class="wizard-check flex-shrink-0 ml-3">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      @click="wizardSettings.businessType = 'takeaway'"
                      class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                      :class="{ 'wizard-choice-active': wizardSettings.businessType === 'takeaway' }">
                      <div class="card-body py-4 px-4">
                        <div class="d-flex align-items-center">
                          <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                            <i class="fas fa-shopping-bag"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h5 class="mb-1">{{ $t('remoteOrder.wizard.step1.takeaway') }}</h5>
                            <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step1.takeawayDesc') }}</small>
                          </div>
                          <div class="wizard-check flex-shrink-0 ml-3">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      @click="wizardSettings.businessType = 'both'"
                      class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                      :class="{ 'wizard-choice-active': wizardSettings.businessType === 'both' }">
                      <div class="card-body py-4 px-4">
                        <div class="d-flex align-items-center">
                          <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                            <i class="fas fa-store"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h5 class="mb-1">{{ $t('remoteOrder.wizard.step1.both') }}</h5>
                            <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step1.bothDesc') }}</small>
                          </div>
                          <div class="wizard-check flex-shrink-0 ml-3">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 2: Customer message -->
                <div v-if="wizardStep === 2">
                  <h5 class="mb-4">{{ $t('remoteOrder.wizard.step2.title') }}</h5>
                  <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step2.subtitle') }}</p>

                  <div class="form-group">
                    <label for="wizardCustomerMessage">{{ $t('remoteOrder.wizard.step2.label') }}</label>
                    <textarea v-model="wizardSettings.customerMessage" class="form-control" id="wizardCustomerMessage" rows="1"
                              :placeholder="$t('remoteOrder.wizard.step2.placeholder')"></textarea>
                    <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step2.help') }}</small>
                  </div>
                </div>

                <!-- Step 3: Category selection -->
                <div v-if="wizardStep === 3">
                  <h5 class="mb-4">{{ $t('remoteOrder.wizard.step3.title') }}</h5>
                  <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step3.subtitle') }}</p>

                  <div v-if="categories.length === 0" class="alert alert-warning">
                    <div class="mb-2">
                      <i class="fa-solid fa-triangle-exclamation"></i> {{ $t('remoteOrder.noCategories')}}
                    </div>
                    <div>
                      <a href="/#/categories" target="_blank">{{ $t('remoteOrder.manageCategories')}}</a>
                      ({{ $t('menu.saleSettings') }} -> {{ $t('menu.categories') }})
                    </div>
                  </div>

                  <div v-if="categories.length > 0">
                    <div class="mb-3">
                      <button @click="selectAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.enableAll') }}</button>
                      <button @click="deselectAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.disableAll') }}</button>
                      <button @click="scheduleAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.scheduleAll') }}</button>
                      <button @click="showUnifiedScheduleModal = true" class="btn btn-sm btn-outline-secondary">{{ $t('remoteOrder.category.unifiedSchedule') }}</button>
                    </div>

                    <div v-for="category in categories" v-bind:key="category.categoryId" class="row mb-3 align-items-center">
                      <div class="col-md-2">
                        <strong>{{ category.categoryName }}</strong>
                      </div>
                      <div class="col-md-4">
                        <div class="btn-group btn-group-toggle btn-group-sm w-100" data-toggle="buttons">
                          <label class="btn btn-sm" :class="category.visibility === 'invisible' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'invisible'">
                            {{ $t('category.visibility.invisible') }}
                          </label>
                          <label class="btn btn-sm" :class="category.visibility === 'visible' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'visible'">
                            {{ $t('category.visibility.visible') }}
                          </label>
                          <label class="btn btn-sm" :class="category.visibility === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'scheduled'">
                            {{ $t('category.visibility.scheduled') }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('remoteOrder.schedule.timeFrom') }}</span>
                          </div>
                          <input type="time" class="form-control" v-model="category.fromTime" :disabled="category.visibility !== 'scheduled'">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('remoteOrder.schedule.timeTo') }}</span>
                          </div>
                          <input type="time" class="form-control" v-model="category.toTime" :disabled="category.visibility !== 'scheduled'">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 4: Payment requirement -->
                <div v-if="wizardStep === 4">
                  <h5 class="mb-4">{{ $t('remoteOrder.wizard.step4.title') }}</h5>
                  <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step4.subtitle') }}</p>

                  <div class="mb-3">
                    <div
                      @click="wizardSettings.paymentRequired = true"
                      class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                      :class="{ 'wizard-choice-active': wizardSettings.paymentRequired === true }">
                      <div class="card-body py-4 px-4">
                        <div class="d-flex align-items-center">
                          <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                            <i class="fas fa-lock"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h5 class="mb-1">{{ $t('remoteOrder.wizard.step4.required') }}</h5>
                            <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step4.requiredDesc') }}</small>
                          </div>
                          <div class="wizard-check flex-shrink-0 ml-3">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      @click="wizardSettings.paymentRequired = false"
                      class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                      :class="{ 'wizard-choice-active': wizardSettings.paymentRequired === false }">
                      <div class="card-body py-4 px-4">
                        <div class="d-flex align-items-center">
                          <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                            <i class="fas fa-unlock"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h5 class="mb-1">{{ $t('remoteOrder.wizard.step4.notRequired') }}</h5>
                            <small class="form-text text-muted">{{ $t('remoteOrder.wizard.step4.notRequiredDesc') }}</small>
                          </div>
                          <div class="wizard-check flex-shrink-0 ml-3">
                            <i class="fas fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step 5: Payment Gateway -->
                <div v-if="wizardStep === 5">
                    <h5 class="mb-4">{{ $t('remoteOrder.paymentGateway.title') }}</h5>
                    <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step5.paymentGatewayInfo') }}</p>
                    <div class="p-3 border rounded">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <strong>{{ $t('remoteOrder.wizard.step5.providerLabel') }}</strong>
                                <span v-if="paymentProvider && paymentProvider !== 'noProvider'" class="font-weight-bold text-success">{{ paymentProvider }}</span>
                                <span v-else class="font-weight-bold text-danger">{{ $t('remoteOrder.wizard.step5.providerNone') }}</span>
                            </div>
                            <button class="btn btn-primary" @click="openPaymentGatewayModal">{{ $t('remoteOrder.wizard.step5.setupButton') }}</button>
                        </div>
                    </div>
                </div>

                <!-- Step 6: Summary -->
                <div v-if="wizardStep === 6">
                  <h5 class="mb-4">{{ $t('remoteOrder.wizard.step5.title') }}</h5>
                  <p class="text-secondary mb-4">{{ $t('remoteOrder.wizard.step5.subtitle') }}</p>

                  <!-- Configuration Warnings -->
                  <div v-if="getSelectedCategoriesCount() === 0 || (wizardSettings.paymentRequired && paymentProvider === 'noProvider')" class="alert alert-warning mb-4">
                    <div class="mb-2">
                      <i class="fas fa-exclamation-triangle mr-2"></i>
                      <strong>{{ $t('remoteOrder.wizard.incompleteConfiguration') }}</strong>
                    </div>
                    <ul class="mb-0 pl-3">
                      <li v-if="getSelectedCategoriesCount() === 0">{{ $t('remoteOrder.wizard.warningNoCategories') }}</li>
                      <li v-if="wizardSettings.paymentRequired && paymentProvider === 'noProvider'">{{ $t('remoteOrder.wizard.warningNoPaymentGateway') }}</li>
                    </ul>
                  </div>

                  <!-- Remote Order System State -->
                  <div class="mb-4 p-3 border rounded">
                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                      <div class="mb-2 mb-md-0">
                        <strong>{{ $t('remoteOrder.systemTitle') }}</strong>
                        <div :class="{'text-success': remoteOrderState === 'open', 'text-danger': remoteOrderState === 'closed', 'small': remoteOrderState === 'scheduled'}">{{ getRemoteOrderStateText() }}</div>
                      </div>
                      <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label class="btn btn-sm" :class="remoteOrderState === 'closed' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('closed')">
                              {{ $t('remoteOrder.state.closed') }}
                          </label>
                          <label class="btn btn-sm" :class="remoteOrderState === 'open' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('open')">
                              {{ $t('remoteOrder.state.open') }}
                          </label>
                          <label class="btn btn-sm" :class="remoteOrderState === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="setRemoteOrderState('scheduled')">
                              {{ $t('remoteOrder.state.scheduled') }}
                          </label>
                      </div>
                    </div>
                    <div v-if="remoteOrderState === 'scheduled'" class="mt-3 d-flex justify-content-between align-items-center">
                      <div v-if="weekOpenCloseSettings && weekOpenCloseSettings.actualTime">
                        {{ $t('remoteOrder.schedule.actualTime') }}: {{ hourMinuteToTimeString(weekOpenCloseSettings.actualTime) }} - <strong :class="weekOpenCloseSettings.openNow ? 'text-success' : 'text-danger'">{{ weekOpenCloseSettings.openNow ? $t('remoteOrder.schedule.openNow') : $t('remoteOrder.schedule.closedNow') }}</strong>
                      </div>
                      <button class="btn btn-link btn-sm text-decoration-none p-0 ml-auto" @click="showScheduleDetails = !showScheduleDetails">
                        {{ showScheduleDetails ? $t('remoteOrder.schedule.hide') : $t('remoteOrder.schedule.show') }}
                        <i class="fas ml-1" :class="showScheduleDetails ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </button>
                    </div>

                    <!-- Schedule Settings -->
                    <div v-if="showScheduleDetails" class="mt-4 pt-3 border-top">
                      <h5 class="mb-3">{{ $t('remoteOrder.schedule.title') }}</h5>
                      <div v-for="(day, index) in weekSchedule" :key="index" class="row mb-3 align-items-center">
                          <div class="col-md-2">
                              <strong>{{ $t(day.nameKey) }}</strong>
                          </div>
                          <div class="col-md-4">
                              <div class="btn-group btn-group-toggle btn-group-sm w-100">
                                  <label class="btn btn-sm" :class="day.state === 'closed' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'closed'">
                                      {{ $t('remoteOrder.dayState.closed') }}
                                  </label>
                                  <label class="btn btn-sm" :class="day.state === 'open' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'open'">
                                      {{ $t('remoteOrder.dayState.open') }}
                                  </label>
                                  <label class="btn btn-sm" :class="day.state === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click="day.state = 'scheduled'">
                                      {{ $t('remoteOrder.dayState.scheduled') }}
                                  </label>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="input-group input-group-sm">
                                  <div class="input-group-prepend">
                                      <span class="input-group-text">{{ $t('remoteOrder.schedule.timeFrom') }}</span>
                                  </div>
                                  <input type="time" class="form-control" v-model="day.from" :disabled="day.state !== 'scheduled'">
                                  <div class="input-group-prepend">
                                      <span class="input-group-text">{{ $t('remoteOrder.schedule.timeTo') }}</span>
                                  </div>
                                  <input type="time" class="form-control" v-model="day.to" :disabled="day.state !== 'scheduled'">
                              </div>
                          </div>
                      </div>
                      <div class="d-flex justify-content-end">
                          <button class="btn btn-success" @click="saveWeekSchedule">
                              <i class="fas fa-save mr-2"></i>{{ $t('remoteOrder.schedule.save') }}
                          </button>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4">
                    <div class="mb-3">
                      <strong>{{ $t('remoteOrder.wizard.step5.businessType') }}</strong>
                      <span v-if="wizardSettings.businessType === 'table'">{{ $t('remoteOrder.wizard.step1.table') }}</span>
                      <span v-if="wizardSettings.businessType === 'takeaway'">{{ $t('remoteOrder.wizard.step1.takeaway') }}</span>
                      <span v-if="wizardSettings.businessType === 'both'">{{ $t('remoteOrder.wizard.step1.both') }}</span>
                    </div>

                    <div class="mb-3">
                      <strong>{{ $t('remoteOrder.wizard.step5.message') }}</strong>
                      <span v-if="wizardSettings.customerMessage">{{ wizardSettings.customerMessage }}</span>
                      <span v-else class="text-secondary">{{ $t('remoteOrder.wizard.step5.noMessage') }}</span>
                    </div>

                    <div class="mb-3">
                      <div><strong>{{ $t('remoteOrder.wizard.step5.enabledCategories') }}</strong> {{ getEnabledCategoriesCount() }}</div>
                      <div><strong>{{ $t('remoteOrder.wizard.step5.disabledCategories') }}</strong> {{ getDisabledCategoriesCount() }}</div>
                      <div><strong>{{ $t('remoteOrder.wizard.step5.scheduledCategories') }}</strong> {{ getScheduledCategoriesCount() }}</div>
                    </div>

                    <div class="mb-3">
                      <strong>{{ $t('remoteOrder.wizard.step5.paymentRequired') }}</strong>
                      <span v-if="wizardSettings.paymentRequired">{{ $t('remoteOrder.wizard.step5.paymentRequiredYes') }}</span>
                      <span v-else>{{ $t('remoteOrder.wizard.step5.paymentRequiredNo') }}</span>
                    </div>

                    <div class="mb-3">
                      <strong>{{ $t('remoteOrder.wizard.step5.paymentMethods') }}</strong>
                      <span v-if="paymentProvider && paymentProvider !== 'noProvider'" class="text-success font-weight-bold">{{ paymentProvider }}</span>
                      <span v-else class="text-danger font-weight-bold">{{ $t('remoteOrder.wizard.step5.noPaymentMethod') }}</span>
                    </div>
                  </div>
                </div>

                <!-- Navigation buttons -->
                <div class="d-flex flex-wrap-reverse justify-content-between pt-3">
                  <div>
                    <button v-if="wizardStep > 1" @click="wizardPrevStep" class="btn btn-outline-secondary">
                      <i class="fas fa-arrow-left mr-2"></i>{{ $t('remoteOrder.wizard.previous') }}
                    </button>
                    <button v-else @click="closeWizard" class="btn btn-outline-secondary">
                      {{ $t('remoteOrder.wizard.cancel') }}
                    </button>
                  </div>
                  <div>
                    <button v-if="wizardStep < 6" @click="wizardNextStep" class="btn btn-primary">
                      {{ $t('remoteOrder.wizard.next') }}<i class="fas fa-arrow-right ml-2"></i>
                    </button>
                    <button v-else @click="finishWizard" class="btn btn-success">
                      <i class="fas fa-check mr-2"></i>{{ $t('remoteOrder.wizard.finish') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal: Remote ordering mode -->
        <div class="e-card-backdrop" v-if="showModeSettings">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.buttons.modeSettings') }}</span>
                <i @click="showModeSettings = false" class="fas fa-times e-modal-close-icon"></i>
              </div>
              <div class="card-body py-5 px-4">
                <div class="mb-4 p-3 border rounded">
                  <label for="customerMessage" class="mb-3 font-weight-bold">{{ $t('remoteOrder.mode.customerMessage') }}</label>
                  <textarea v-model="customerMessage" class="form-control" id="customerMessage" rows="1"></textarea>
                  <small class="form-text text-muted">{{ $t('remoteOrder.mode.customerMessageSubtitle') }}</small>
                </div>

                <div class="mb-4 p-3 border rounded">
                  <label class="mb-3 font-weight-bold">{{ $t('remoteOrder.mode.paymentRequired') }}</label>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div
                        @click="paymentRequired = true"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': paymentRequired === true }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-lock"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.paymentRequiredYes') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.paymentRequiredYesDesc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div
                        @click="paymentRequired = false"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': paymentRequired === false }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-unlock"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.paymentRequiredNo') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.paymentRequiredNoDesc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <small class="form-text text-muted">{{ $t('remoteOrder.mode.paymentRequiredSubtitle') }}</small>
                </div>

                <div class="mb-4 p-3 border rounded">
                  <label class="mb-3 font-weight-bold">{{ $t('remoteOrder.mode.showReceiptQrCode') }}</label>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" role="switch" id="showReceiptQrCode" v-model="showReceiptQrCode">
                    <label class="custom-control-label" for="showReceiptQrCode">{{ $t('remoteOrder.mode.showReceiptQrCodeEnable') }}</label>
                  </div>
                  <small class="form-text text-muted">{{ $t('remoteOrder.mode.showReceiptQrCodeSubtitle') }}</small>
                </div>

                <div class="mb-4 p-3 border rounded">
                  <label class="mb-3 font-weight-bold">{{ $t('remoteOrder.mode.template') }}</label>
                  <small class="form-text text-muted mb-3">{{ $t('remoteOrder.mode.templateSubtitle') }}</small>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div
                        @click="selectedTemplate = 'default'"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': selectedTemplate === 'default' }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-file-alt"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.templateDefault') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.templateDefaultDesc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div
                        @click="selectedTemplate = 'template1'"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': selectedTemplate === 'template1' }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-moon"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.template1') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.template1Desc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div
                        @click="selectedTemplate = 'template2'"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': selectedTemplate === 'template2' }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-sun"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.template2') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.template2Desc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div
                        @click="selectedTemplate = 'template3'"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': selectedTemplate === 'template3' }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-leaf"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.template3') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.template3Desc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div
                        @click="selectedTemplate = 'custom'"
                        class="e-inner-card shadow-sm e-rounding mb-3 wizard-choice"
                        :class="{ 'wizard-choice-active': selectedTemplate === 'custom' }">
                        <div class="card-body py-3 px-4">
                          <div class="d-flex align-items-center">
                            <div class="wizard-icon d-flex align-items-center justify-content-center rounded flex-shrink-0 mr-3">
                              <i class="fas fa-code"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1">{{ $t('remoteOrder.mode.templateCustom') }}</h6>
                              <small class="form-text text-muted">{{ $t('remoteOrder.mode.templateCustomDesc') }}</small>
                            </div>
                            <div class="wizard-check flex-shrink-0 ml-3">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="selectedTemplate === 'custom'" class="mt-3">
                    <label for="customTemplate" class="font-weight-bold">{{ $t('remoteOrder.mode.customTemplateLabel') }}</label>
                    <textarea v-model="customTemplate" class="form-control custom-template-textarea" id="customTemplate" rows="10"
                              :placeholder="$t('remoteOrder.mode.customTemplatePlaceholder')"></textarea>
                    <small class="form-text text-muted">{{ $t('remoteOrder.mode.customTemplateSubtitle') }}</small>
                  </div>
                </div>

                <div class="mb-4 p-3 border rounded">
                  <label for="subDomain" class="mb-3 font-weight-bold">{{ $t('remoteOrder.mode.subDomainLabel') }}</label>
                  <div class="input-group subdomain-input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">https://</span>
                    </div>
                    <input v-model="subDomain" id="subDomain" type="text" class="form-control"/>
                    <div class="input-group-append">
                      <span class="input-group-text">.elementary.menu</span>
                    </div>
                  </div>
                  <small class="form-text text-muted">{{ $t('remoteOrder.mode.subDomainSubtitle') }}</small>
                </div>

                <div class="d-flex flex-wrap-reverse justify-content-end pt-3">
                  <button @click="showModeSettings = false" class="btn btn-outline-secondary mr-4">
                    {{ $t('button.back') }}
                  </button>
                  <button @click="saveModeSettings" class="btn btn-primary">
                    {{ $t('button.save') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal: Category settings -->
        <div class="e-card-backdrop" v-if="showCategorySettings">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-8 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.buttons.categorySettings') }}</span>
                <i @click="showCategorySettings = false" class="fas fa-times e-modal-close-icon"></i>
              </div>
              <div class="card-body py-5 px-4">
                <div class="form-group">
                  <label>{{ $t('remoteOrder.selectCategories') }}</label>
                  <div v-if="categories.length === 0" class="my-4">
                    <div class="text-danger"><i class="fa-solid fa-triangle-exclamation"></i> {{ $t('remoteOrder.noCategories')}}</div>
                    <a href="/#/categories">{{ $t('remoteOrder.manageCategories')}}</a>
                    ({{ $t('menu.saleSettings') }} -> {{ $t('menu.categories') }})
                  </div>
                  <div v-if="categories.length > 0" class="mb-3">
                    <button @click="selectAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.enableAll') }}</button>
                    <button @click="deselectAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.disableAll') }}</button>
                    <button @click="scheduleAllCategories" class="btn btn-sm btn-outline-secondary mr-2">{{ $t('remoteOrder.category.scheduleAll') }}</button>
                    <button @click="showUnifiedScheduleModal = true" class="btn btn-sm btn-outline-secondary">{{ $t('remoteOrder.category.unifiedSchedule') }}</button>
                  </div>
                  <div v-for="category in categories" v-bind:key="category.categoryId" class="row mb-3 align-items-center">
                    <div class="col-md-2">
                      <strong>{{ category.categoryName }}</strong>
                    </div>
                    <div class="col-md-4">
                      <div class="btn-group btn-group-toggle btn-group-sm w-100" data-toggle="buttons">
                        <label class="btn btn-sm" :class="category.visibility === 'invisible' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'invisible'">
                          {{ $t('category.visibility.invisible') }}
                        </label>
                        <label class="btn btn-sm" :class="category.visibility === 'visible' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'visible'">
                          {{ $t('category.visibility.visible') }}
                        </label>
                        <label class="btn btn-sm" :class="category.visibility === 'scheduled' ? 'btn-primary' : 'btn-outline-primary'" @click.prevent="category.visibility = 'scheduled'">
                          {{ $t('category.visibility.scheduled') }}
                        </label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('remoteOrder.schedule.timeFrom') }}</span>
                        </div>
                        <input type="time" class="form-control" v-model="category.fromTime" :disabled="category.visibility !== 'scheduled'">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('remoteOrder.schedule.timeTo') }}</span>
                        </div>
                        <input type="time" class="form-control" v-model="category.toTime" :disabled="category.visibility !== 'scheduled'">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-wrap-reverse justify-content-end pt-3">
                  <button @click="showCategorySettings = false" class="btn btn-outline-secondary mr-4">
                    {{ $t('button.back') }}
                  </button>
                  <button @click="saveCategorySettings" class="btn btn-primary">
                    {{ $t('button.save') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal: Payment gateway -->
        <div class="e-card-backdrop" v-if="showPaymentGateway">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.paymentGateway.title') }}</span>
                <i @click="showPaymentGateway = false" class="fas fa-times e-modal-close-icon"></i>
              </div>
              <div class="card-body py-5 px-4">

                <!-- Provider selection -->
                <div class="form-group">
                  <label for="paymentProviderSelect">{{ $t('remoteOrder.paymentGateway.placeholder') }}</label>
                  <select v-model="paymentProvider" id="paymentProviderSelect" class="form-control">
                    <option value="noProvider">{{ $t('remoteOrder.paymentGateway.selectProvider') }}</option>
                    <option value="goPay">GoPay</option>
                    <option value="stripe">Stripe</option>
                    <option value="test">{{ $t('remoteOrder.paymentGateway.testProviderDesc') }}</option>
                  </select>
                </div>

                <!-- GoPay fields -->
                <div v-if="paymentProvider === 'goPay'">
                  <div class="form-group">
                    <label for="goPayId">GoPay ID</label>
                    <input type="text" v-model="goPayId" id="goPayId" class="form-control" :placeholder="$t('remoteOrder.paymentGateway.goPayIdPlaceholder')">
                  </div>
                  <div class="form-group">
                    <label for="goPayClientId">Client ID</label>
                    <input type="text" v-model="goPayClientId" id="goPayClientId" class="form-control" :placeholder="$t('remoteOrder.paymentGateway.clientIdPlaceholder')">
                  </div>
                  <div class="form-group">
                    <label for="goPayClientSecret">Client Secret</label>
                    <input type="password" v-model="goPayClientSecret" id="goPayClientSecret" class="form-control" :placeholder="$t('remoteOrder.paymentGateway.clientSecretPlaceholder')">
                  </div>
                </div>

                <!-- Stripe fields -->
                <div v-if="paymentProvider === 'stripe'">
                  <div class="form-group">
                    <label for="stripeApiKey">API Key</label>
                    <input type="password" v-model="stripeApiKey" id="stripeApiKey" class="form-control" :placeholder="$t('remoteOrder.paymentGateway.stripeApiKeyPlaceholder')">
                  </div>
                </div>

                <div class="mt-3">
                  {{ $t('remoteOrder.paymentGateway.termsConditionsInfo') }}<br>
                <label for="termsConditionsUrl">{{ $t('remoteOrder.paymentGateway.termsConditionsUrl') }}</label>
                <input type="text" v-model="termsConditionsUrl" id="termsConditionsUrl" class="form-control">
                </div>

                <div class="mt-3">
                  {{ $t('remoteOrder.paymentGateway.privacyPolicyInfo') }}<br>
                  <label for="privacyPolicyUrl">{{ $t('remoteOrder.paymentGateway.privacyPolicyUrl') }}</label>
                  <input type="text" v-model="privacyPolicyUrl" id="privacyPolicyUrl" class="form-control">
                </div>

                <div class="mt-3">
                  {{ $t('remoteOrder.paymentGateway.contactInfoInfo') }}<br>
                  <label for="contactInfo">{{ $t('remoteOrder.paymentGateway.contactInfoLabel') }}</label>
                  <textarea v-model="contactInfo" class="form-control" id="contactInfo" rows="4"></textarea>
                </div>

                <!-- Buttons -->
                <div class="d-flex justify-content-between pt-3">
                  <button @click="showPaymentGateway = false" class="btn btn-outline-secondary">
                    {{ $t('button.back') }}
                  </button>
                  <button @click="savePaymentProviderSettings" class="btn btn-primary"
                          :disabled="!isPaymentProviderFormValid()">
                    {{ $t('button.save') }}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Modal: QR Codes with Tabs -->
        <div class="e-card-backdrop" v-if="showQRDownload">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-8 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.qrDownload.title') }}</span>
                <i @click="showQRDownload = false" class="fas fa-times e-modal-close-icon"></i>
              </div>

              <!-- Tabs -->
              <ul class="nav nav-tabs" style="background-color: #cccccc">
                <li class="nav-item">
                  <a class="nav-link elColor"
                     v-bind:class="{'active': qrTab === 'global', 'elActive': qrTab === 'global'}"
                     href="#"
                     @click="qrTab = 'global'">
                    <i class="fas fa-globe mr-2"></i>{{ $t('remoteOrder.qrDownload.global') }}
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link elColor"
                     v-bind:class="{'active': qrTab === 'locale', 'elActive': qrTab === 'locale'}"
                     href="#"
                     @click="switchToLocaleTab">
                    <i class="fas fa-utensils mr-2"></i>{{ $t('remoteOrder.qrDownload.locale') }}
                  </a>
                </li>
              </ul>

              <div class="card-body py-4 px-4">
                <!-- Global/Takeaway QR Tab -->
                <div v-if="qrTab === 'global'">
                  <h5 class="mb-3">{{ $t('remoteOrder.qrDownload.globalTitle') }}</h5>
                  <div class="text-center mb-4">
                    <a :href="globalQrUrl" target="_blank">
                    <img :src="bu + '/remote-order-settings/get-global-qr-code?ak=' + ak"
                         width="250"
                         alt="Global QR Code"
                         class="mb-3"/>
                    </a>
                    <div>
                      <a :href="bu + '/remote-order-settings/get-global-qr-code?ak=' + ak"
                         class="btn btn-sm btn-primary mb-3"
                         download>
                        <i class="fas fa-download mr-1"></i>{{ $t('remoteOrder.downloadQRCode') }}
                      </a>
                    </div>
                    <div class="mt-3">
                      <label class="font-weight-bold">{{ $t('remoteOrder.qrDownload.urlLabel') }}:</label>
                      <div class="input-group">
                        <input type="text" class="form-control" :value="globalQrUrl || '...'" readonly />
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary"
                                  @click="copyToClipboard(globalQrUrl)"
                                  :disabled="!globalQrUrl">
                            <i class="fas fa-copy"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Locale/Permanent QR Tab -->
                <div v-if="qrTab === 'locale'">
                  <h5 class="mb-3">{{ $t('remoteOrder.qrDownload.localeTitle') }}</h5>
                  <div v-if="permanentBills.length === 0" class="alert alert-warning">
                    <i class="fas fa-exclamation-triangle"></i> {{ $t('remoteOrder.qrDownload.noPermanentBills') }}
                  </div>
                  <div v-else class="row">
                    <div v-for="bill in permanentBills" :key="bill.billId" class="col-12 col-md-4 mb-3">
                      <div class="border rounded p-3 text-center">
                        <h6 class="mb-3">{{ bill.name }}</h6>
                        <a :href="localQrUrls[bill.billId]" target="_blank">
                        <img :src="bu + '/remote-order-settings/get-permanent-bill-qr-code?ak=' + ak + '&billId=' + bill.billId"
                             width="180"
                             alt="QR Code"
                             class="mb-2"/>
                        </a>
                        <div class="mb-3">
                          <a :href="bu + '/remote-order-settings/get-permanent-bill-qr-code?ak=' + ak + '&billId=' + bill.billId"
                             class="btn btn-sm btn-primary"
                             download>
                            <i class="fas fa-download mr-1"></i>{{ $t('remoteOrder.downloadQRCode') }}
                          </a>
                        </div>
                        <div class="input-group mb-2">
                          <input type="text"
                                 class="form-control form-control-sm"
                                 :value="localQrUrls[bill.billId] || '...'"
                                 readonly />
                          <div class="input-group-append">
                            <button class="btn btn-sm btn-outline-secondary"
                                    @click="copyToClipboard(localQrUrls[bill.billId])"
                                    :disabled="!localQrUrls[bill.billId]">
                              <i class="fas fa-copy"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end pt-3 border-top">
                  <button @click="showQRDownload = false" class="btn btn-outline-secondary">
                    {{ $t('button.back') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal: Unified Schedule -->
        <div class="e-card-backdrop" v-if="showUnifiedScheduleModal">
          <div class="row e-modal-row justify-content-center align-items-start">
            <div class="e-modal-card col-10 col-lg-4 bg-white shadow-sm e-rounding p-0">
              <div class="card-header e-user__header">
                <span>{{ $t('remoteOrder.category.unifiedSchedule') }}</span>
                <i @click="showUnifiedScheduleModal = false" class="fas fa-times e-modal-close-icon"></i>
              </div>
              <div class="card-body py-4 px-4">
                <p class="text-secondary mb-3">{{ $t('remoteOrder.category.unifiedScheduleDescription') }}</p>

                <div class="input-group input-group-sm mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('remoteOrder.schedule.timeFrom') }}</span>
                  </div>
                  <input type="time" class="form-control" v-model="unifiedFromTime">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('remoteOrder.schedule.timeTo') }}</span>
                  </div>
                  <input type="time" class="form-control" v-model="unifiedToTime">
                </div>

                <div class="d-flex justify-content-between pt-3">
                  <button @click="showUnifiedScheduleModal = false" class="btn btn-outline-secondary">
                    {{ $t('button.cancel') }}
                  </button>
                  <button @click="applyUnifiedSchedule" class="btn btn-primary">
                    {{ $t('button.save') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
</template>

<script>
    import Loader from "@/components/Loader"
    import PremiumBanner from "@/components/PremiumBanner";
    import {baseURL} from '@/config/variables'

    export default {
        name: 'RemoteOrderSettings',
        components: { Loader, PremiumBanner },

        data: function () {
            return {
                loading: true,
                bu: baseURL,
                ak: localStorage.apiKey,

                // Hlavní stav komponenty
                remoteOrderState: "closed",
                customerMessage: "",
                subDomain: "",
                categories: [],
                type: "",
                provider: "",
                paymentRequired: false,
                selectedTemplate: 'default',
                customTemplate: '',
                showReceiptQrCode: false,
                permanentBills: [],

                // Stav pro modální okna
                showWizard: false,
                showModeSettings: false,
                showCategorySettings: false,
                showPaymentGateway: false,
                showQRDownload: false,
                showUnifiedScheduleModal: false,

                // Dočasná nastavení pro průvodce
                wizardSettings: null,
                wizardStep: 1,

                // Stav pro platební brány
                paymentProvider: 'noProvider',
                goPayId: '',
                goPayClientId: '',
                goPayClientSecret: '',
                stripeApiKey: '',
                termsConditionsUrl: '',
                privacyPolicyUrl: '',
                contactInfo: '',

                // Stav pro QR kódy
                qrTab: 'global',
                globalQrUrl: '',
                localQrUrls: {},

                // Stav pro week open/close settings
                weekOpenCloseSettings: null,
                weekSchedule: [
                    { nameKey: 'remoteOrder.day.monday', state: 'closed', from: '08:00', to: '17:00' },
                    { nameKey: 'remoteOrder.day.tuesday', state: 'closed', from: '08:00', to: '17:00' },
                    { nameKey: 'remoteOrder.day.wednesday', state: 'closed', from: '08:00', to: '17:00' },
                    { nameKey: 'remoteOrder.day.thursday', state: 'closed', from: '08:00', to: '17:00' },
                    { nameKey: 'remoteOrder.day.friday', state: 'closed', from: '08:00', to: '17:00' },
                    { nameKey: 'remoteOrder.day.saturday', state: 'closed', from: '10:00', to: '14:00' },
                    { nameKey: 'remoteOrder.day.sunday', state: 'closed', from: '10:00', to: '14:00' }
                ],
                showScheduleDetails: false,

                // Stav pro jednotný rozvrh kategorií
                unifiedFromTime: '08:00',
                unifiedToTime: '17:00',
            }
        },

        mounted: function () {
            this.refresh();
        },

        watch: {
            wizardStep(newStep) {
                if (newStep === 6 && this.remoteOrderState === 'scheduled') {
                    this.getWeekOpenCloseSettings();
                }
            }
        },

        methods: {
            refresh: function() {
                const vm = this;
                vm.loading = true;
                this.$http.post('/remote-order-settings/get-ro-settings', {})
                    .then(function(response) {
                        vm.customerMessage = response.data.customerMessage;
                        vm.subDomain = response.data.subDomain;
                        vm.categories = response.data.categories.map(function(cat) {
                            return {
                                categoryId: cat.categoryId,
                                categoryName: cat.categoryName,
                                visibility: cat.visibility.visibility,
                                fromTime: vm.hourMinuteToTimeString(cat.visibility.from),
                                toTime: vm.hourMinuteToTimeString(cat.visibility.to)
                            };
                        });
                        vm.type = response.data.type;
                        vm.provider = response.data.provider;
                        vm.paymentProvider = response.data.provider || 'noProvider';
                        vm.paymentRequired = response.data.type === 'firstPay';
                        vm.selectedTemplate = response.data.template || 'default';
                        vm.customTemplate = response.data.customTemplate || '';
                        vm.showReceiptQrCode = response.data.showReceiptQrCode === true;
                        return vm.$http.post('/bill/get-all-bills-fe', {});
                    })
                    .then(function(response) {
                        vm.permanentBills = response.data.permanentBills;
                    })
                    .catch(function(error) {
                        console.error('Error getting remote order settings or bills:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
                vm.getRoSettingsState();
                vm.getWeekOpenCloseSettings();
            },

            openWizard: function() {
                // Vytvoříme kopii aktuálních nastavení pro úpravy v průvodci
                this.wizardSettings = {
                    businessType: '', // Pouze pro logiku zobrazení v průvodci
                    customerMessage: this.customerMessage,
                    subDomain: this.subDomain,
                    paymentRequired: this.paymentRequired,
                    selectedTemplate: this.selectedTemplate
                };
                this.getPaymentProviderSettings(); // Načteme aktuální stav brány
                this.wizardStep = 1;
                this.showWizard = true;
            },

            finishWizard: function() {
                const vm = this;
                vm.loading = true;

                const payload = {
                    customerMessage: vm.wizardSettings.customerMessage,
                    subDomain: vm.wizardSettings.subDomain,
                    type: vm.wizardSettings.paymentRequired ? 'firstPay' : 'firstBill',
                    template: vm.wizardSettings.selectedTemplate || vm.selectedTemplate,
                    customTemplate: vm.customTemplate,
                    showReceiptQrCode: vm.showReceiptQrCode,
                    categories: vm.categories.map(function(c) {
                        return {
                            categoryId: c.categoryId,
                            visibility: {
                                visibility: c.visibility,
                                from: vm.timeStringToHourMinute(c.fromTime),
                                to: vm.timeStringToHourMinute(c.toTime)
                            }
                        };
                    })
                };

                this.$http.post('/remote-order-settings/update-ro-settings', payload)
                    .then(function () {
                        vm.refresh(); // Po úspěšném uložení znovu načteme všechna data
                    })
                    .catch(function (error) {
                        console.error('Error finishing wizard:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                        vm.showWizard = false;
                    });
            },

            saveModeSettings: function() {
                const vm = this;
                vm.loading = true;
                const categoriesToSave = vm.categories.map(function(c) {
                    return {
                        categoryId: c.categoryId,
                        visibility: {
                            visibility: c.visibility,
                            from: vm.timeStringToHourMinute(c.fromTime),
                            to: vm.timeStringToHourMinute(c.toTime)
                        }
                    };
                });
                const typeValue = vm.paymentRequired ? 'firstPay' : 'firstBill';
                this.$http.post('/remote-order-settings/update-ro-settings', {
                  categories: categoriesToSave,
                  customerMessage: vm.customerMessage,
                  subDomain: vm.subDomain,
                  type: typeValue,
                  template: vm.selectedTemplate,
                  customTemplate: vm.customTemplate,
                  showReceiptQrCode: vm.showReceiptQrCode
                })
                    .then(function () {
                      vm.showModeSettings = false;
                      vm.refresh();
                    })
                    .catch(function (error) {
                      console.error('Error saving mode settings:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            },

            saveCategorySettings: function() {
                const vm = this;
                vm.loading = true;
                const categoriesToSave = vm.categories.map(function(c) {
                    return {
                        categoryId: c.categoryId,
                        visibility: {
                            visibility: c.visibility,
                            from: vm.timeStringToHourMinute(c.fromTime),
                            to: vm.timeStringToHourMinute(c.toTime)
                        }
                    };
                });
                this.$http.post('/remote-order-settings/update-ro-settings', {
                  categories: categoriesToSave,
                  customerMessage: vm.customerMessage,
                  subDomain: vm.subDomain,
                  type: vm.type,
                  template: vm.selectedTemplate,
                  customTemplate: vm.customTemplate,
                  showReceiptQrCode: vm.showReceiptQrCode
                })
                    .then(function () {
                      vm.showCategorySettings = false;
                      vm.refresh();
                    })
                    .catch(function (error) {
                      console.error('Error saving category settings:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            },

            openQRModal: function() {
                this.showQRDownload = true;
                this.loadGlobalQR();
            },

            loadGlobalQR: function() {
                const vm = this;
                vm.$http.post('/remote-order-settings/get-global-qr-code-link', {})
                    .then(function (response) {
                        vm.globalQrUrl = response.data.url;
                    })
                    .catch(function (error) {
                        console.error('Error loading global QR code link:', error);
                    });
            },

            switchToLocaleTab: function() {
                this.qrTab = 'locale';
                this.loadAllLocalQRs();
            },

            loadAllLocalQRs: function() {
                this.permanentBills.forEach(bill => {
                    if (!this.localQrUrls[bill.billId]) {
                        this.loadLocalQR(bill.billId);
                    }
                });
            },

            loadLocalQR: function(billId) {
                const vm = this;
                vm.$http.post('/remote-order-settings/get-local-qr-code-link', {
                    billId: billId
                })
                    .then(function (response) {
                        vm.$set(vm.localQrUrls, billId, response.data.url);
                    })
                    .catch(function (error) {
                        console.error('Error loading local QR code link for billId ' + billId + ':', error);
                    });
            },

            copyToClipboard: function(text) {
                const vm = this;
                if (text) {
                    navigator.clipboard.writeText(text).then(function() {
                        vm.$modal.cs_alert(vm.$t('remoteOrder.qrDownload.urlCopied'));
                    }).catch(function(err) {
                        console.error('Could not copy text using navigator.clipboard, falling back to execCommand.', err);
                        const textArea = document.createElement('textarea');
                        textArea.value = text;
                        document.body.appendChild(textArea);
                        textArea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textArea);
                        vm.$modal.cs_alert(vm.$t('remoteOrder.qrDownload.urlCopied'));
                    });
                }
            },

            closeWizard: function() {
                this.showWizard = false;
                this.wizardStep = 1;
            },

            wizardNextStep: function() {
                this.wizardStep++;
            },
            wizardPrevStep: function() {
                if (this.wizardStep > 1) {
                    this.wizardStep--;
                }
            },

            getSelectedCategoriesCount: function() {
                return this.categories.filter(c => c.visibility === 'visible' || c.visibility === 'scheduled').length;
            },

            getEnabledCategoriesCount: function() {
                return this.categories.filter(c => c.visibility === 'visible').length;
            },

            getDisabledCategoriesCount: function() {
                return this.categories.filter(c => c.visibility === 'invisible').length;
            },

            getScheduledCategoriesCount: function() {
                return this.categories.filter(c => c.visibility === 'scheduled').length;
            },

            selectAllCategories: function() {
                this.categories.forEach(c => c.visibility = 'visible');
            },

            deselectAllCategories: function() {
                this.categories.forEach(c => c.visibility = 'invisible');
            },

            scheduleAllCategories: function() {
                this.categories.forEach(c => c.visibility = 'scheduled');
            },

            applyUnifiedSchedule: function() {
                const vm = this;
                vm.categories.forEach(function(c) {
                    c.visibility = 'scheduled';
                    c.fromTime = vm.unifiedFromTime;
                    c.toTime = vm.unifiedToTime;
                });
                vm.showUnifiedScheduleModal = false;
            },

            getRoSettingsState: function() {
                const vm = this;
                this.$http.post('/remote-order-settings/get-ro-settings-state', {})
                    .then(function (response) {
                        vm.remoteOrderState = response.data.state;
                    })
                    .catch(function (error) {
                        console.error('Error getting remote order settings state:', error);
                    });
            },

            openPaymentGatewayModal: function() {
                this.showPaymentGateway = true;
                this.getPaymentProviderSettings();
            },

            getPaymentProviderSettings: function() {
                const vm = this;
                this.$http.post('/remote-order-settings/get-ro-payment-provider-settings', {})
                    .then(function (response) {
                        vm.paymentProvider = response.data.provider || 'noProvider';
                        if (response.data.provider === 'goPay' && response.data.goPaySettings) {
                            vm.goPayId = response.data.goPaySettings.goPayId || '';
                            vm.goPayClientId = response.data.goPaySettings.clientId || '';
                            vm.goPayClientSecret = response.data.goPaySettings.clientSecret || '';
                        } else if (response.data.provider === 'stripe' && response.data.stripeSettings) {
                            vm.stripeApiKey = response.data.stripeSettings.apiKey || '';
                        }
                        vm.termsConditionsUrl = response.data.termsConditionsUrl || '';
                        vm.privacyPolicyUrl = response.data.privacyPolicyUrl || '';
                        vm.contactInfo = response.data.contactInfo || '';
                    })
                    .catch(function (error) {
                        console.error('Error getting payment provider settings:', error);
                    });
            },

            savePaymentProviderSettings: function() {
                const vm = this;
                vm.loading = true;
                let payload = {
                  provider: vm.paymentProvider,
                  termsConditionsUrl: vm.termsConditionsUrl,
                  privacyPolicyUrl: vm.privacyPolicyUrl,
                  contactInfo: vm.contactInfo
                };
                if (vm.paymentProvider === 'goPay') {
                    payload.goPaySettings = {
                        goPayId: vm.goPayId,
                        clientId: vm.goPayClientId,
                        clientSecret: vm.goPayClientSecret
                    };
                } else if (vm.paymentProvider === 'stripe') {
                    payload.stripeSettings = {
                        apiKey: vm.stripeApiKey
                    };
                }
                this.$http.post('/remote-order-settings/update-ro-payment-provider-settings', payload)
                    .then(function () {
                        vm.showPaymentGateway = false;
                    })
                    .catch(function (error) {
                        console.error('Error saving payment provider settings:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            },

            isPaymentProviderFormValid: function() {
                if (!this.paymentProvider) return false;
                if (this.paymentProvider === 'noProvider') return true;
                if (this.paymentProvider === 'goPay') {
                    return this.goPayId && this.goPayClientId && this.goPayClientSecret;
                }
                if (this.paymentProvider === 'stripe') {
                    return this.stripeApiKey;
                }
                if (this.paymentProvider === 'test') {
                  return true;
                }
                return false;
            },
            openModeSettingsModal: function() {
                this.showModeSettings = true;
            },

            timeStringToHourMinute: function(timeStr) {
                if (!timeStr) return null;
                const parts = timeStr.split(':');
                return {
                    hour: parseInt(parts[0], 10),
                    minute: parseInt(parts[1], 10)
                };
            },

            hourMinuteToTimeString: function(hourMinute) {
                if (!hourMinute) return '';
                const h = String(hourMinute.hour).padStart(2, '0');
                const m = String(hourMinute.minute).padStart(2, '0');
                return h + ':' + m;
            },

            getWeekOpenCloseSettings: function() {
                const vm = this;
                this.$http.post('/remote-order-settings/get-week-open-close-settings', {})
                    .then(function (response) {
                        vm.weekOpenCloseSettings = response.data;
                        if (response.data && response.data.days && response.data.days.length === 7) {
                            vm.weekSchedule = vm.weekSchedule.map(function(day, index) {
                                const apiDay = response.data.days[index];
                                return {
                                    nameKey: day.nameKey,
                                    state: apiDay.state,
                                    from: vm.hourMinuteToTimeString(apiDay.from),
                                    to: vm.hourMinuteToTimeString(apiDay.to)
                                };
                            });
                        }
                    })
                    .catch(function (error) {
                        console.error('Error getting week open/close settings:', error);
                    });
            },

            saveWeekSchedule: function() {
                const vm = this;
                vm.loading = true;
                const days = vm.weekSchedule.map(function(day) {
                    const apiDay = {
                        state: day.state
                    };
                    if (day.from && day.to) {
                        apiDay.from = vm.timeStringToHourMinute(day.from);
                        apiDay.to = vm.timeStringToHourMinute(day.to);
                    }
                    return apiDay;
                });
                this.$http.post('/remote-order-settings/update-week-open-close-settings', {
                    state: vm.remoteOrderState,
                    days: days
                })
                    .then(function () {
                        vm.$modal.cs_alert(vm.$t('remoteOrder.schedule.saved'));
                        vm.getWeekOpenCloseSettings();
                    })
                    .catch(function (error) {
                        console.error('Error saving week schedule:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            },

            getRemoteOrderStateText: function() {
                switch (this.remoteOrderState) {
                    case 'open':
                        return this.$t('remoteOrder.systemActive');
                    case 'closed':
                        return this.$t('remoteOrder.systemInactive');
                    case 'scheduled':
                        return this.$t('remoteOrder.state.scheduledDescription');
                    default:
                        return this.$t('remoteOrder.systemInactive');
                }
            },

            setRemoteOrderState: function(state) {
                const vm = this;
                if (vm.remoteOrderState === state) {
                    if (state === 'scheduled') {
                        vm.getWeekOpenCloseSettings();
                    }
                    return;
                }
                vm.loading = true;
                this.$http.post('/remote-order-settings/update-ro-settings-state', {
                    state: state
                })
                    .then(function () {
                        vm.remoteOrderState = state;
                        vm.showScheduleDetails = false;
                        vm.weekOpenCloseSettings = null;
                        vm.getWeekOpenCloseSettings();
                    })
                    .catch(function (error) {
                        console.error('Error updating remote order state:', error);
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>

  .remote-order-illustration {
    display: block;
    max-width: 540px;
    width: 100%;
    margin: 0 auto 1.5rem;
  }

  input[type="time"]:disabled {
    opacity: 0.5;
}

.custom-template-textarea {
  font-family: monospace;
  font-size: 0.875rem;
}

.wizard-choice {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.wizard-choice:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

.wizard-choice-active {
  border-color: #19415b;
  background-color: #f0f8ff;
}

.wizard-icon {
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  font-size: 1.5rem;
  color: #6c757d;
  transition: all 0.2s ease;
}

.wizard-choice-active .wizard-icon {
  background-color: #19415b;
  color: white;
}

.wizard-check {
  font-size: 1.5rem;
  color: #dee2e6;
  transition: all 0.2s ease;
}

.wizard-choice-active .wizard-check {
  color: #419c30;
}

@media screen and (max-width: 576px) {
  .wizard-icon {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }
  .wizard-check {
    font-size: 1.2rem;
  }
}

.subdomain-input-group {
  flex-wrap: nowrap;
}
.subdomain-input-group > .form-control {
  flex: 1 1 0;
  min-width: 0;
  width: auto;
}
@media screen and (max-width: 576px) {
  .subdomain-input-group > .input-group-prepend > .input-group-text,
  .subdomain-input-group > .input-group-append > .input-group-text {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.875rem;
  }
  .subdomain-input-group > .form-control {
    font-size: 0.875rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
}

</style>